import { isAsofomOrganization } from "@/share/imef";

const getEntityId = (value) => {
  if (value && typeof value === "object") return value._id || value.id || null;
  return value || null;
};

export const getCommunityLabel = (user) => {
  if (!user) return "Mi Comunidad";

  const userId = getEntityId(user._id);
  const headOfficeId = getEntityId(user.headOffice);
  const organizationId = getEntityId(user.organization);

  return isAsofomOrganization(userId, headOfficeId)
    || isAsofomOrganization(userId, organizationId)
    ? "Proyectos Comités"
    : "Mi Comunidad";
};
